module.exports = __webpack_public_path__ + "img/forward_button.6ecb243a.png";